
import * as _asset0 from "inline-asset:assets/galleries/test/L1000398-bw_47e4f02e52__20.jpg";
import * as _asset1 from "asset:assets/galleries/test/L1000398-bw_47e4f02e52__400.jpg";
import * as _asset2 from "asset:assets/galleries/test/L1000398-bw_47e4f02e52__800.jpg";
import * as _asset3 from "asset:assets/galleries/test/L1000398-bw_47e4f02e52__1600.jpg";


export default {
  id: "L1000398-bw",
  aspect: 1.5123647604327666,
  alt: undefined,
  sources: [{
              url: _asset0.url,
              width: 20,
            },{
              url: _asset1.url,
              width: 400,
            },{
              url: _asset2.url,
              width: 800,
            },{
              url: _asset3.url,
              width: 1600,
            }],
};
        